svg.logo {
  display: none;
}

.print-spacer-margin {
  height: 0;
}

/* #workflow-name {
 
} */

.task-status-lozenge {
  padding: 0.35rem 1rem;
  background-color: #7066ff;
  border-radius: 2rem;
  color: white;
  font-weight: 400;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.task-status-live {
  padding: 0.35rem 1rem 0.35rem 0.8rem;
  background-color: rgb(216, 142, 3);
}

#workflow-print-name {
  text-align: left;
  margin: 0;
  padding: 0rem 0 1.5rem;
  font-size: 1.2rem;
  display: none;
}

.timeline-wrapper {
  display: flex;
  height: 100%;
  align-items: stretch;
}

.back-button {
  color: white;
  font-size: 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.back-button {
  color: #3b3630;
}

.back-button svg path {
  fill: #3b3630;
}

.back-button:hover {
  color: #ffa705;
}

.dark-mode .back-button {
  color: #ffffff;
}

.dark-mode .back-button svg path {
  fill: #ffffff;
}

.dark-mode .back-button:hover {
  color: #ffa705;
}

#container {
  margin: 0;
  /* MP Changed to fix map/question list scrolling = TBD Testing wise */
  max-height: 100vh;
}

#map {
  display: none;
  height: 100%;
}

.start {
  padding-top: 1rem;
}

.end {
  padding-bottom: 3rem;
}

.state {
  width: 1rem;
  display: inline-block;
  height: 1rem;
  background-color: gray;
  border-radius: 2rem;
  border: 2px solid white;
}

.status {
  display: flex;
  flex-direction: row;
  align-items: center;
  -webkit-align-items: center;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  padding-right: 1.5rem;
}

.nav {
  color: #424242;
}

.chevronWrapper {
  display: flex;
}

svg.chevron {
  border-radius: 5rem;
  padding: 0.5rem 0.5rem 0.5rem 0.6rem;
}

svg.chevron:hover {
  background-color: #e3e3e3;
  border-radius: 5rem;
  padding: 0.5rem 0.5rem 0.5rem 0.6rem;
}

.dark-mode svg.chevron:hover {
  background-color: #544e6d;
}

.dark-mode .nav {
  color: white;
}

.dark-mode h1,
.dark-mode h3,
.dark-mode .relative,
.dark-mode .eventTime,
.dark-mode .response,
.dark-mode .answer,
.dark-mode .question,
.dark-mode .showDetails,
.dark-mode .task-status {
  color: white;
}

.dark-mode .question,
.dark-mode h2,
.dark-mode .comment {
  color: #ffb429;
}

.dark-mode .logic-wrapper {
  background-color: #50505f;
  color: #acacac;
}

.dark-mode .chevron path {
  fill: white;
}

.dark-mode {
  background: #31313e;
}

.dark-mode .relative,
.dark-mode .eventTime,
.dark-mode .state {
  background-color: #362f55;
  border: 1px solid white;
}

.dark-mode .state.live {
  background-color: #ffa705;
  color: #362f55;
  padding: 0.5rem 1rem 0.5rem 0.5rem;
}

.logic-wrapper {
  padding: 0.5rem 0.65rem;
  border-radius: 0.25rem;
  filter: drop-shadow(0 6px 4px rgb(0 0 0 / 0.04))
    drop-shadow(0 2px 1.5px rgb(0 0 0 / 0.1));
  margin-left: 1rem;
  color: #50505f;
  background-color: #ffffff;
  min-width: 5rem;
}

.logic-wrapper svg {
  fill: #4c4c4c;
}

.dark-mode .logic-wrapper svg {
  fill: #c2c2c2;
}

.end-state {
  background-color: red;
}

.live-state {
  background-color: green;
}

.start-day {
  text-align: right;
  padding-right: 1rem;
}

.start-info {
  padding-bottom: 1rem;
}

.log-title {
  font-weight: 500;
}

.eventTimeline {
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0.5rem;
  flex: 1 1 auto;
}

.eventTimeline > * {
  margin-bottom: 0.5rem;
}

.eventTime {
  font-size: 0.9rem;
}

.event {
  flex: 1;
}

.eventWrapper {
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
}

.eventScrollTarget {
  scroll-margin-block: 1rem;
}

.event-footer {
  display: flex;
  margin-bottom: 4rem !important;
}

.start-end-wrapper {
  flex-direction: column;
}

.start-end-wrapper .eventHeader {
  flex-direction: column;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  padding: 0;
}

.start-end-wrapper .event {
  background: none !important;
  filter: none !important;
}

.eventHeader {
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  -webkit-align-items: center;
  width: auto;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}

.smallDate {
  font-size: 0.7rem;
  text-align: right;
  margin-top: 1rem;
}

.chevron-rotated {
  transform: rotate(90deg);
}

div.question,
div.answer {
  color: #057988;
  margin-right: 0.75rem;
}

.workflow-event {
  display: flex;
  align-items: center;
  text-transform: capitalize;
  font-size: 0.7rem;
  gap: 0.5rem;
}

span.answer {
  color: #c409b1;
}

.response {
  font-size: 0.925rem;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: row;
  color: #424242;
  line-height: 1.25rem;
}

.answerBody {
  max-width: 85%;
}

.answerBody a {
  color: #057988;
}

.photoAnswer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  margin: 0;
}

.photoAnswerCaption {
  color: gray;
  font-size: 0.8rem;
}

.detailsWrapper {
  display: flex;
  border-top: 1px solid #dddddd;
  padding: 1.5rem 1.75rem;
  margin-top: 1rem;
  gap: 1rem;
  flex-direction: column;
  font-size: 0.8rem;
  text-transform: capitalize;
}

.hideDetails {
  display: none;
}

.showDetails {
  display: flex;
}

.detailsWrapper span {
  font-weight: 700;
}

.ended,
.started {
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.eventTime,
.eventAux {
  display: none;
}

.photoList {
  list-style: none;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  gap: 0.5rem;
  width: 100%;
  margin: 1.5rem 0 1rem;
  padding: 0;
}

.photoList > * {
  flex: 0 0 auto;
}

.photoItem {
  display: block;
  width: 8.5rem;
  aspect-ratio: 4/3;
  object-fit: cover;
  border-radius: 0.5rem;
  margin: 0;
}

.signatureItem {
  object-fit: contain;
  background: #ffffff;
}

.imagePreviewButton {
  appearance: none;
  position: relative;
  display: block;
  width: 8.5rem;
  aspect-ratio: 4/3;
  margin: 0;
  padding: 0;
  overflow: hidden;
  border: 0;
  border-radius: 0.5rem;
  background: #f1f3f5;
  cursor: pointer;
}

.imagePreviewButton .photoItem {
  width: 100%;
  height: 100%;
  aspect-ratio: auto;
  border-radius: inherit;
}

.imagePreviewButton:focus-visible {
  outline: 3px solid #2563eb;
  outline-offset: 2px;
}

.imagePreviewOverlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(55, 65, 81, 0.68);
  opacity: 0;
  transition: opacity 160ms ease;
  pointer-events: none;
}

.imagePreviewButton:hover .imagePreviewOverlay,
.imagePreviewButton:focus-visible .imagePreviewOverlay {
  opacity: 1;
}

.imagePreviewIcon {
  width: 2.5rem;
  height: 2.5rem;
  fill: #ffffff;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.45));
}

.commentsPhotos {
  border-top: 1px solid #e4e4e4;
  margin-top: 1rem;
  padding-top: 1rem;
  max-width: 27rem;
}

.comment {
  font-size: 0.8rem;
  color: gray;
}

.noComment {
  margin-top: 0;
}

.comment .response {
  margin-top: 1rem;
}

.responseWrapper {
  width: 100%;
}

.lightboxDialog {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 4.5rem 2rem 2rem;
  outline: none;
  pointer-events: none;
}

.lightboxImage {
  display: block;
  width: auto;
  height: auto;
  max-width: calc(100vw - 4rem);
  max-height: calc(100vh - 6.5rem);
  object-fit: contain;
  border-radius: 0.75rem;
  border: 2px solid white;
  background: #111827;
  box-shadow: 0 1.5rem 4rem rgba(0, 0, 0, 0.55);
  pointer-events: auto;
}

.lightboxSignature {
  box-sizing: border-box;
  padding: 1rem;
  background: #ffffff;
}

.lightboxCloseButton {
  appearance: none;
  position: fixed;
  top: 1.25rem;
  right: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 999px;
  background: rgba(17, 24, 39, 0.72);
  color: #ffffff;
  cursor: pointer;
  pointer-events: auto;
  transition: background-color 160ms ease, transform 160ms ease;
}

.lightboxCloseButton:hover {
  background: rgba(55, 65, 81, 0.95);
  transform: scale(1.05);
}

.lightboxCloseButton:focus-visible {
  outline: 3px solid #93c5fd;
  outline-offset: 2px;
}

.lightboxCloseButton svg {
  width: 2rem;
  height: 2rem;
  fill: currentColor;
}

.lightboxNavigationButton {
  appearance: none;
  position: fixed;
  top: 50%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 999px;
  background: rgba(17, 24, 39, 0.72);
  color: #ffffff;
  cursor: pointer;
  pointer-events: auto;
  transform: translateY(-50%);
  transition: background-color 160ms ease, transform 160ms ease;
}

.lightboxNavigationButton:hover {
  background: rgba(55, 65, 81, 0.95);
  transform: translateY(-50%) scale(1.05);
}

.lightboxNavigationButton:focus-visible {
  outline: 3px solid #93c5fd;
  outline-offset: 2px;
}

.lightboxNavigationButton svg {
  width: 2.5rem;
  height: 2.5rem;
  fill: currentColor;
}

.lightboxPreviousButton {
  left: 1.25rem;
}

.lightboxNextButton {
  right: 1.25rem;
}

@media (max-width: 640px) {
  .lightboxDialog {
    padding-right: 1rem;
    padding-left: 1rem;
  }

  .lightboxImage {
    max-width: calc(100vw - 2rem);
  }

  .lightboxNavigationButton {
    width: 3rem;
    height: 3rem;
  }

  .lightboxPreviousButton {
    left: 0.75rem;
  }

  .lightboxNextButton {
    right: 0.75rem;
  }
}

.task-status {
  margin-right: 2rem;
}

.last-accessed h3,
.task-status h3 {
  font-size: 0.85rem;
  padding: 1.5rem 0rem 1rem 0rem;
  font-weight: 400;
}

.relative,
.state {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  background-color: #d8d8d8;
  border-radius: 2rem;
  height: 1rem;
  padding: 0.5rem 1rem;
  font-weight: 400;
  margin: auto 0rem;
  border: 2px solid white;
  width: fit-content;
}

.lightning {
  animation: lightning 1s linear infinite;
}

@keyframes lightning {
  100% {
    opacity: 0;
  }
}

/* Switch styling */

#controls {
  display: flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  padding: 1.5rem;
  border-right: 1px solid #e4e4e4;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.dark-mode .slider {
  background-color: #cacaca;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: #8d8d8d;
  transition: 0.4s;
  border-radius: 50%;
}

.dark-mode .slider:before {
  background-color: #31313e;
}

input:checked + .slider {
  background-color: #d8d8d8;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.no-map-warning {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  margin: 3rem 0 0 0;
}

.no-map-warning div {
  background-color: #db0303;
  padding: 0.5rem 1.5rem;
  border-radius: 2rem;
  color: white;
}

.marker-tag {
  align-items: center;
  background-color: rgb(43, 43, 113);
  border-radius: 50%;
  color: #fff;
  display: flex;
  font-size: 16px;
  font-weight: 600;
  gap: 15px;
  height: 30px;
  justify-content: center;
  padding: 4px;
  position: relative;
  position: relative;
  transition: all 0.3s ease-out;
  width: 30px;
}

.marker-tag::after {
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-top: 9px solid rgb(43, 43, 113);
  content: "";
  height: 0;
  left: 50%;
  position: absolute;
  top: 95%;
  transform: translate(-50%, 0);
  transition: all 0.3s ease-out;
  width: 0;
  z-index: 1;
}

    .mapEventMarker {
    align-items: center;
    background-color: #1f124a;
    border-radius: 50%;
    color: #263238;
    display: flex;
    font-size: 14px;
    gap: 15px;
    height: 30px;
    justify-content: center;
    padding: 4px;
    position: relative;
    transition: all 0.3s ease-out;
    width: 30px;
  }

  .mapEventMarker::after {
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-top: 9px solid #1f124a;
    content: "";
    height: 0;
    left: 50%;
    position: absolute;
    top: 95%;
    transform: translate(-50%, 0);
    transition: all 0.3s ease-out;
    width: 0;
    z-index: 1;
  }

  .mapMarkerIcon {
    align-items: center;
    display: flex;
    justify-content: center;
    color: #fff;
    border-radius: 30px;
    padding: 5px;
    z-index: inherit;
  }

  .mapMarkerIcon svg {
    height: 20px;
    width: auto;
  }

  .mapMarkerDetails {
    display: none;
    flex-direction: column;
    flex: 1;
  }

  .mapMarkerAnswer {
    margin-bottom: 10px;
    margin-top: 5px;
  }

  .mapMarkerFeatures {
    align-items: flex-end;
    display: flex;
    flex-direction: row;
    gap: 10px;
  }

  .mapMarkerFeatures > div {
    align-items: center;
    background: #f5f5f5;
    border-radius: 5px;
    border: 1px solid #ccc;
    display: flex;
    font-size: 10px;
    gap: 5px;
    padding: 5px;
  }

  .mapEventMarkerHighlight {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.2);
    height: 80px;
    padding: 8px 15px;
    width: 20rem;
    position: relative;
    z-index: 2;
  }

  .mapEventMarkerHighlight::after {
    border-top: 9px solid #fff;
  }

  .mapEventMarkerHighlight .mapMarkerDetails {
    display: flex;
    max-width: 20rem;
  }

  .mapEventMarkerHighlight .mapMarkerQuestion {
    line-height: 24px;
    overflow: hidden;
    white-space: nowrap;
    max-width: 16rem;
    text-overflow: ellipsis;
  }

  .mapEventMarkerHighlight .mapMarkerIcon svg {
    width: 26px;
    height: 26px;
    border-radius: 40px;
    padding: 4px;
  }

.yellowColour {
  background-color: #F3BB25;
}
.orangeColour {
  background-color: #f8a305;
}

.marker-tag.orangeColour::after {
  border-top: 9px solid #f8a305;
}

.dark-orangeColour {
  background-color: #de4500;
}

.marker-tag.dark-orangeColour::after {
  border-top: 9px solid #de4500;
}

.mid-brownColour {
  background-color: #a36405;
}

.marker-tag.mid-brownColour::after {
  border-top: 9px solid #a36405;
}

.pinkColour {
  background-color: #ff0466;
}

.marker-tag.pinkColour::after {
  border-top: 9px solid #ff0466;
}

.tealColour {
  background-color: #03769f;
}

.mintColour {
  background-color: #00c797;
}

.fusciaColour {
  background-color: #d50a62;
}

.jungle-greenColour {
  background-color: #829806;
}

.hot-pinkColour {
  background-color: #ef04ff;
}

.marker-tag.tealColour::after {
  border-top: 9px solid #03769f;
}

.light-blueColour {
  background-color: #1a65c7;
}

.marker-tag.light-blueColour::after {
  border-top: 9px solid #1a65c7;
}

.violetColour {
  background-color: #6f24d1;
}

.marker-tag.violetColour::after {
  border-top: 9px solid #6f24d1;
}

.greenColour {
  background-color: #0e8d0a;
}

.marker-tag.greenColour::after {
  border-top: 9px solid #0e8d0a;
}

.goldColour {
  background-color: #a36405;
}

.marker-tag.goldColour::after {
  border-top: 9px solid #a36405;
}

.redColour {
  background-color: #d51010;
}

.marker-tag.redColour::after {
  border-top: 9px solid #d51010;
}

.purpleColour {
  background-color: #62098b;
}

.marker-tag.purpleColour::after {
  border-top: 9px solid #62098b;
}

.turquoiseColour {
  background-color: #056966;
}

.marker-tag.turquoiseColour::after {
  border-top: 9px solid #056966;
}


.context-menu-wrapper{
  position:relative;

}

.card {
  height: 10rem;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transform: translateZ(0);
  border-radius: 0.7rem;
  overflow: hidden;
  height: auto;
  cursor: pointer;
}
/* TASK DETAIL CONTEXT MENU */
.context-menu {
  background-color: white;
  filter: drop-shadow(0 3px 3px rgb(0 0 0 / 0.3));
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  width: 12rem;
  position: absolute;
  top: 2.95rem;
  right: 0.5rem;
  list-style: none;
  overflow: hidden;
}

.context-menu li{
  text-align: left;
  width: fit-content;
  padding: 1rem 1.5rem;
  width: initial;
  display: flex;
  flex-direction: row;
  gap: 0.5rem
}

.context-menu li:hover {
  font-weight: 500;
  cursor: pointer;
}

.context-menu li:first-child{
  border-bottom: 1px solid #d3d3d3;
}

.context-menu-wrapper {
    display: none;
}

.context-menu-wrapper.show {
  display: block;
}

.context-menu-selector {
  width: 26px;
  height:26px;
}

/* Obsolete Overlay */
.modal {
  background-color: white;
  padding: 0.5rem 1.5rem 2rem;
  min-width: 18rem;
  box-shadow: 3px 3px 6px #000000;
}

.form-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 1rem;
  align-items: center;
  margin-bottom: 1rem;
}

.modal h2 {
  margin: 0;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.6;
  letter-spacing: 0.0075em;
  text-transform: none;
  color: black;
}

.modal label {
  margin: 0;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: 0.00938em;
  margin-top: 16px;
  margin-bottom: 0px;
  color: black;
}

.modal .lower button {
  text-transform: uppercase;
}

form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  justify-content: start;
}

textarea {
  padding: 1rem 0.75rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  border: 1px solid #dddddd;
  font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

.obsolete-popup .lower {
  padding-top: 2rem;
  justify-content: start;
  display: flex;
  flex-direction: row;
} 

.obsolete-popup .lower button {
  background-color: rgb(79 70 229);
  padding: 12px 24px;
}

.obsolete-popup .lower button:hover {
  background-color: #272333;
  color: #ffffff;
}

@media (min-width: 48em) {
  #container {
    border-right: 1px solid #e4e4e4;
  }

  .smallDate {
    display: none;
  }

  /* .eventWrapper {
  } */

  .eventTime {
    display: block;
    font-size: 0.85rem;
    background-color: #d8d8d8;
    border-radius: 2rem;
    height: 2rem;
    padding: 0.35rem 1rem 0.5rem;
    font-weight: 400;
    margin: auto 1.75rem;
    border: 2px solid white;
  }

  .obsolete {
    font-size: 0.65rem;
    font-weight: 800;
  }

  .eventTimeline {
    padding: 0;
  }

  .eventTimeline > * {
    /* margin-bottom: 1rem; */
    margin-bottom: 0.35rem;
  }

  .eventAux {
    display: flex;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='1'><linearGradient id='gradient'><stop offset='10%' stop-color='%23e4e4e4'/><stop offset='90%' stop-color='%23e4e4e4'/> </linearGradient><rect fill='black' x='0' y='0' width='100%' height='100%'/></svg>");
    background-repeat: no-repeat;
    background-position: center center;
    /* background-size: cover; */
  }

  .dark-mode .eventAux {
    display: flex;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='1'><linearGradient id='gradient'><stop offset='10%' stop-color='%23e4e4e4'/><stop offset='90%' stop-color='%23e4e4e4'/> </linearGradient><rect fill='url(%23gradient)' x='0' y='0' width='100%' height='100%'/></svg>");
    background-repeat: no-repeat;
    background-position: center center;
  }

  .eventIcon {
    display: flex;
    border-radius: 4rem;
    /* text-indent: -9999px; */
    height: 2.75rem;
    width: 2.75rem;
    padding: 0.35rem;
    margin: 0rem 1rem 0 0;
    border: 2px solid white;
    filter: drop-shadow(0 6px 4px rgb(0 0 0 / 0.04))
      drop-shadow(0 2px 1.5px rgb(0 0 0 / 0.1));
    align-self: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
  }

  .geolocation {
    display: none;
  }

  .eventIcon:hover .geolocation {
    /* background-color: #fff; */
    display: block;
  }

  .eventIcon:hover > .geolocation path {
    fill: white;
  }

  .iconLable {
    display: none;
    position: absolute;
    z-index: 999;
    border-radius: 1rem;
    background-color: #2b2b2b;
    padding: 0.35rem 0.5rem;
    font-size: 0.7rem;
    color: white;
    top: 2.5rem;
    left: -4.5rem;
    width: 5rem;
    text-align: center;
    filter: drop-shadow(0 6px 4px rgb(0 0 0 / 0.01))
      drop-shadow(0 2px 1.5px rgb(0 0 0 / 0.4));
  }

  .showLabel {
    display: block;
  }

  /* Obsolete overlay */

  .modal {
    min-width: 30rem;
  }

}

@media (min-width: 60em) {
  #map {
    display: block;
    width: 100%;
    /* padding: 2rem; */
    height: 100%;
  }
}

@media (min-width: 80em) {
  .timeline-area {
    min-width: 40%;
    min-height: 100%;
    overflow: scroll;
    background-color: rgb(226, 232, 240);
    /* filter: drop-shadow(0 6px 4px rgb(0 0 0 / 0.04)) drop-shadow(0 2px 1.5px rgb(0 0 0 / 0.1)); */
  }
}

@media print {
  .print {
    display: none !important;
  }
}
